import TextField, { TextFieldProps } from "@mui/material/TextField";

const TextFieldComponent = (props: TextFieldProps) => {
  return <TextField {...props} />;
};
export default TextFieldComponent;
